import { useTranslation } from 'react-i18next';
import { Box, Button, Card, CardHeader, Tooltip } from '@mui/material';
import { Loader, NotifyIcon, NotifyTypo } from 'web-components';
import { PlcType } from '../../../../attrs/plcConfigValues';

const labelAmend = 'machines.detail';

interface AutomationSystemCardLoaderProps {
  automationSystem: {
    plc_type: string;
  };
}

const AutomationSystemCardLoader = ({ automationSystem }: AutomationSystemCardLoaderProps) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ p: 4, my: 2 }}>
      <CardHeader
        sx={{ p: 0, alignItems: 'flex-start', mb: 0 }}
        title={
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ mt: '15px', fontSize: '16px' }}>{t(`${labelAmend}.automation_system.title`)}</Box>
          </Box>
        }
        titleTypographyProps={{
          fontWeight: '500',
          variant: 'body1'
        }}
        action={
          <Tooltip
            title={t(`machines.detail.plc_not_filled`)}
            disableHoverListener={automationSystem.plc_type !== PlcType.UNKNOWN}
            arrow
          >
            <span>
              <Button
                variant="text"
                disabled={true}
                sx={{ p: 1.5, gap: 1, display: 'flex', height: '50px', width: '96px' }}
              >
                <NotifyIcon iconName="edit" fontSize="medium" />
                {t('machines.machine_details.edit')}
              </Button>
            </span>
          </Tooltip>
        }
      />
      <NotifyTypo.Subtitle1 fontWeight="400">{t(`${labelAmend}.automation_system.subtitle`)}</NotifyTypo.Subtitle1>
      <Box sx={{ my: '20px' }}>
        <Loader />
      </Box>
    </Card>
  );
};

export default AutomationSystemCardLoader;
